import React, { useState } from "react";
import { API } from "../../lib/api";

export const StreetViewImage = ({ lat, lng, w = 640, h = 400, className, alt, fallback = null }) => {
  const [failed, setFailed] = useState(false);
  if (!lat || !lng || failed) return fallback;
  return (
    <img
      src={`${API}/streetview?lat=${lat}&lng=${lng}&w=${w}&h=${h}`}
      alt={alt || "Street view"}
      loading="lazy"
      onError={() => setFailed(true)}
      className={className}
      data-testid="streetview-image"
    />
  );
};

export default StreetViewImage;
